// extracted by mini-css-extract-plugin
export var container = "_as-0";
export var icon = "_as-1";
export var text = "_as-2";